import { Tag } from '../../../ontology.model';

export const partialFractionsTags: Tag[] = [
  {
    id: 'tag.pf',
    name: 'Partial Fractions',
    parent_id: 'tag.alg',
    icon: 'divide',
    description:
      'Decomposing rational expressions into simpler fractions. Covers linear factors, repeated factors, and improper fractions.',
  },
  {
    id: 'tag.pf.decomp',
    name: 'Decomposition Process',
    parent_id: 'tag.pf',
    icon: 'sitemap',
    description: 'The standard partial fractions decomposition workflow for proper rational expressions.',
  },
  {
    id: 'tag.pf.improper',
    name: 'Improper Fractions',
    parent_id: 'tag.pf',
    icon: 'arrow-up-right-dots',
    description:
      'Rational expressions where the numerator degree is greater than or equal to the denominator degree, requiring polynomial division first.',
  },
];
